import React, { useEffect, useState } from "react";
import styles from "./school-coursework.module.css";
import { Typography } from "antd";
import CustomButton from "../../../../../../../common/custom-button/custom-button";
import { PlusOutlined } from "@ant-design/icons";
import CustomTable from "../../../../../../../common/custom-table/custom-table";
import SVGIcon from "../../../../../../../constants/SVGIcon";
import CustomPopover from "../../../../../../../common/custom-popover/custom-popover";
import { deleteCourseworkType, fetchCourseworkType } from "../../../../../../../services/school_info";
import AddEditCoursework from "./components/add-edit-coursework/add-edit-coursework";

const SchoolCoursework = () => {
  const [courseworks, setCourseworks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setPageNo(1);
    getCourseTypes();
  }, []);

  const getCourseTypes = async (tempPage = pageNo, tempPageSize = pageSize) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };
      const response = await fetchCourseworkType(payload);
      if (response?.data) {
        const data = response?.data?.data?.levels;
        setCourseworks(data);
        setTotalCount(response?.data?.data?.totalRecords);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getCourseTypes(page, pageSize);
  };

  const handleEditCoursework = (data) => {
    setEditDetails(data);
    setOpenDrawer(true);
  };

  const handleOnClose = () => {
    getCourseTypes();
    setOpenDrawer(false);
  };

  const handleDeleteCoursework = async (id) => {
    try {
      await deleteCourseworkType(id);
      getCourseTypes();
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddCoursework = () => {
    setEditDetails(null);
    setOpenDrawer(true);
  };

  const columns = [
    {
      title: "Coursework Type",
      dataIndex: "coursework_type_name",
      key: "coursework_type_name",
      sorter: (a, b) => a?.coursework_type_name?.localeCompare(b?.coursework_type_name),
      render: (value) => value || "-",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div className={styles.actionItemWrapper}>
          <SVGIcon
            name={"edit-icon"}
            width={"20"}
            height={"20"}
            stroke={"#3BB44B"}
            onClick={() => handleEditCoursework(record)}
          />
          <CustomPopover
            message="Are you sure you want to delete this coursework?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={() => handleDeleteCoursework(record?.id)}
          >
            <SVGIcon
              name={"delete"}
              width={"20"}
              height={"20"}
              stroke={"rgba(243, 17, 17, 1)"}
            />
          </CustomPopover>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={styles.titleContainer}>
        <Typography className={styles.tabTitle}>
          Coursework Types
        </Typography>
        <CustomButton
          title="Add New Coursework"
          size="large"
          icon={<PlusOutlined />}
          onClick={handleAddCoursework}
        />
      </div>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={courseworks}
          loading={loading}
          headerColor="#667085"
          headerBackgroundColor="#F9FAFB"
          total={totalCount}
          pageSize={pageSize}
          currentPage={pageNo}
          handlePageChange={handleChangePage}
        />
      </div>
      <AddEditCoursework
        open={openDrawer} 
        onClose={handleOnClose} 
        data={editDetails}
      />
    </div>
  );
};

export default SchoolCoursework;